import { Injectable } from '@angular/core';
import {
  CanActivate,
  Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from '@angular/router';
import { AuthService } from '../services/auth.service';

@Injectable({ providedIn: 'root' })
export class GuestGuard implements CanActivate {
  constructor(
    private authService: AuthService,
    private router: Router
  ) { }

  public canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    // If user is already authenticated, redirect to dashboard
    if (this.authService.isAuthenticated()) {
      // Check if user needs to change password
      if (this.authService.requiresPasswordChange()) {
        this.router.navigate(['/wachtwoord-wijzigen']);
        return false;
      }

      // Check if user needs to select company
      if (this.authService.needsCompanySelection()) {
        this.router.navigate(['/bedrijf-selecteren']);
        return false;
      }

      // Already authenticated with everything set up, go to dashboard
      this.router.navigate(['/dashboard']);
      return false;
    }

    // Not authenticated, allow access to login/forgot password pages
    return true;
  }
}
